import { RcFile } from 'antd/es/upload/interface';

import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { Form } from '@form/common.style';

import { DragUpload, Icon, IconWrapper } from './upload.style';

interface UploadInterface {
  text?: string;
  accept?: string;
  onFile?: (file: RcFile, FileList: RcFile[]) => boolean | void;
}

export const Upload = ({ text = 'Support for a single or bulk upload.', accept, onFile }: UploadInterface) => (
  <Form.Item noStyle>
    <DragUpload accept={accept} beforeUpload={onFile}>
      <IconWrapper>
        <Icon color={'red'} />
      </IconWrapper>
      <Text color={ColorEnum.Black100} level='m' mb={4} paragraph>
        Click or drag file to this area to upload
      </Text>
      <Text color={ColorEnum.Black70} level='s' mb={4} paragraph>
        {text}
      </Text>
    </DragUpload>
  </Form.Item>
);
